import Cookies from "js-cookie";

const TEST_EMAIL = "iaaijojojo97@gmail.com";
const API = "https://www.smart-lend.com/api/myinfo/fapi-trial";
const contextKey = state => `sl_fapi_trial_${state}`;

export const isNetrustTrialEntry = () =>
  window.location.pathname === "/stg-b-profile" &&
  (Cookies.get("email") || "").trim().toLowerCase() === TEST_EMAIL;

const cookieOptions = () => ({
  path: "/",
  sameSite: "Lax",
  secure: true,
  expires: 30 / (24 * 60),
  ...(window.location.hostname === "smart-lend.com" || window.location.hostname.endsWith(".smart-lend.com")
    ? { domain: ".smart-lend.com" } : {}),
});

export async function startNetrustTrial(dataSource) {
  if (!isNetrustTrialEntry()) return false;
  const response = await fetch(`${API}/authorise`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${Cookies.get("token")}` },
    body: JSON.stringify({ data_source: dataSource, entrypoint: window.location.pathname }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Unable to start the authentication trial.");
  if (!data.full_login_url || !data.session_id || !data.state || !data.context) {
    throw new Error("Incomplete authentication session. Please start again.");
  }
  const url = new URL(data.full_login_url);
  const allowedHosts = dataSource === "corppass"
    ? ["id.singpass.gov.sg", "stg-id.singpass.gov.sg", "id.corppass.gov.sg", "stg-id.corppass.gov.sg"]
    : ["id.singpass.gov.sg", "stg-id.singpass.gov.sg"];
  if (url.protocol !== "https:" || !allowedHosts.includes(url.hostname)) {
    throw new Error("Unexpected authentication URL. Please start again.");
  }
  // Key by the exact provider state so legacy callbacks and other providers cannot select this flow.
  const key = contextKey(data.state);
  Cookies.set(key, JSON.stringify({ dataSource, state: data.state, sessionId: data.session_id, context: data.context }), cookieOptions());
  if (!Cookies.get(key)) throw new Error("Please enable cookies before starting authentication.");
  if (dataSource === "myinfo") Cookies.set("latest_session_id", data.session_id, cookieOptions());
  // Both existing callback hosts need access to the logged-in borrower's API token.
  const token = Cookies.get("token");
  if (token && cookieOptions().domain) Cookies.set("token", token, { ...cookieOptions(), expires: 7 });
  window.location.href = data.full_login_url;
  return true;
}

export const hasNetrustTrialContext = state => Boolean(state && Cookies.get(contextKey(state)));

export function netrustTrialResolveRequest(dataSource, code, state) {
  const raw = state && Cookies.get(contextKey(state));
  if (!raw) return null;
  let saved;
  try { saved = JSON.parse(raw); } catch { throw new Error("Invalid authentication trial session. Please start again."); }
  if (saved.dataSource !== dataSource || saved.state !== state || !saved.context || !saved.sessionId) {
    throw new Error("Authentication trial session does not match. Please start again.");
  }
  return {
    sessionId: saved.sessionId,
    url: `${API}/resolve`,
    body: { data_source: dataSource, code, state, context: saved.context },
  };
}

export const isNetrustTrialCallback = () => hasNetrustTrialContext(new URLSearchParams(window.location.search).get("state"));
